import { FC, ReactElement } from 'react'

import { SvgIconProps } from '@/components/Icon/Icon'

export const IconFileText: FC<SvgIconProps> = ({ className = '' }): ReactElement => (
    <svg
        aria-hidden="true"
        className={`icon-component ${className}`}
        viewBox="0 0 24 24"
        fill="none"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path className="stroke" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline className="stroke" points="14 2 14 8 20 8" />
        <line className="stroke" x1="16" y1="13" x2="8" y2="13" />
        <line className="stroke" x1="16" y1="17" x2="8" y2="17" />
        <polyline className="stroke" points="10 9 9 9 8 9" />
    </svg>
)
